import { useContext } from 'react';

import { DriversContext } from '../context';
import { DriversContextProps } from '../context/types';

export function useDrivers(): DriversContextProps {
    return useContext(DriversContext);
}
